import { useEffect, useState } from 'react';
import { useSettings } from '@wu/widget-core';
import { Main } from './main';
import { Popup } from './popup/popup';
import { TriggerButton } from './popup/trigger-button';

export function Widget() {
  const settings = useSettings();
  const [displayPopup, setDisplayPopup] = useState(false);
  const ariaLabel = 'Appointment Booking Popup';

  useEffect(() => {
    if (
      settings.editMode &&
      !settings.renderThumbnailMode &&
      !settings.displayDeactivation
    ) {
      const isTriggerButtonEditing = !!settings.editingItems?.['triggerButton'];
      setDisplayPopup(!isTriggerButtonEditing);
    }
  }, [settings.editingItems, settings.editMode, settings.renderThumbnailMode]);

  useEffect(() => {
    if (
      settings.editMode &&
      !settings.renderThumbnailMode &&
      !settings.displayDeactivation
    ) {
      const isPopup = ['floating-button', 'inline-button'].includes(
        settings.embedType
      );
      setDisplayPopup(isPopup);
    }
  }, [settings.embedType, settings.editMode, settings.renderThumbnailMode]);

  return {
    'inline-form': <Main />,
    'inline-button': (
      <>
        <TriggerButton onClick={() => setDisplayPopup(true)} />
        <Popup
          show={displayPopup}
          ariaLabel={ariaLabel}
          onCloseRequest={() => setDisplayPopup(false)}
        >
          <Main />
        </Popup>
      </>
    ),
    'floating-button': (
      <>
        <TriggerButton onClick={() => setDisplayPopup(true)} floating />
        <Popup
          show={displayPopup}
          ariaLabel={ariaLabel}
          onCloseRequest={() => setDisplayPopup(false)}
        >
          <Main />
        </Popup>
      </>
    )
  }[settings.embedType];
}
